import ReportsResult from './ResultPage';

export default ReportsResult;
